import { defineStore } from 'pinia'
import { services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'
import _ from 'lodash'

export const useFinancialProposalStore = defineStore('financialProposalStore', {
	state: () => ({
		financialProposalDetail: {},
		financial_proposal: {},
	}),
	getters: {
	},
	actions: {
		async getFinancialProposal(proposal,current_customer) {
			const postData = {
					im2u_customer_id: current_customer.customer_id,
					psal_id: proposal.psal_id,
					customer_name: current_customer.name,
					customer_email: current_customer.email,
					customer_nric: current_customer.nric,
					agent_name: current_customer.se != null ? current_customer.se.name : current_customer.sse != null ? current_customer.sse.name : null,
					agent_email: current_customer.se != null ? current_customer.se.email : current_customer.sse != null ? current_customer.sse.email : null,
					agent_contact_number: current_customer.se != null ? current_customer.se.name : current_customer.sse != null ? current_customer.sse.name : null,
			};

			let res = await axios.post(services.financial_proposal + 'create_customer_financial_proposal_data', postData, {headers: getHeader()});
			this.financialProposalDetail = _gHlp.getValue(res,'data.data','X');

			return this.financialProposalDetail
		},
	}
})